import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import './sentry.setup';

import { App } from '#app';
import { initStore } from '#features';
import { Loader, SentryErrorBoundary, logger } from '#shared';

import { initWidgets } from './widgets';

const root = createRoot(document.getElementById('root') as HTMLElement);

initWidgets();
const { store, persistor } = initStore();

root.render(
  <StrictMode>
    {/* SpecRef: ARCH-005 */}
    {/* Reference: docs/decisions/ARCH-005-ui-error-detection-resilience.md#1-sentryerrorboundary-placement */}
    {/* Outermost catch-all boundary: reports to Sentry and shows fallback instead of blank screen. */}
    <SentryErrorBoundary showDialog={false}>
      <BrowserRouter>
        <Provider store={store}>
          <PersistGate loading={<Loader />} persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
      </BrowserRouter>
    </SentryErrorBoundary>
  </StrictMode>,
);
logger.info(`App started`);
